import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String, turbo: { type: Boolean, default: true } };

  connect() {
    if (this.turboValue) {
      Turbo.visit(this.urlValue);
    } else {
      window.location.assign(this.urlValue);
    }
  }
}
